<template>
    <div >
        <v-overlay :value="overlay" absolute style="z-index: 9999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    <v-icon class="mb-1">mdi-cube-outline</v-icon>
                    PRODUCTOS
                </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn class="mx-4" small color="primary" @click="showToolbar = !showToolbar">
                    <v-icon small>mdi-filter-variant</v-icon> 
                </v-btn>
                <v-btn small color="primary" @click="abrirDialogProducto(null)">
                    <v-icon>mdi-plus-circle-outline</v-icon> Nuevo producto
                </v-btn>
            </v-toolbar>

            <v-toolbar v-if="showToolbar" flat style="border-bottom: 2px inset lightgray; border-top:1px solid lightgray" > 
                <v-col cols="2">
                    <v-text-field v-model="search"  append-icon="mdi-magnify" label="Buscar producto" @keyup.enter="cargarLista()"
                         ></v-text-field>
                </v-col>

                <v-col cols="2">
                    <v-select v-model="categoriaProducto" :items="categoriasProducto" clearable @change="cargarLista()"
                        label="Categoria" item-text="text" item-value="value" class="mt-2"></v-select>
                </v-col>

                <v-col cols="2">
                    <v-select v-model="tipoProducto" :items="tiposProducto" @change="cargarLista()"
                        label="Tipo producto" item-text="text" item-value="value" clearable class="mt-2"></v-select>
                </v-col>

            </v-toolbar>

            <v-data-table :headers="headers" :items="lista" :items-per-page="itemsPerPage" :search="search"
                :loading="loadingTable" class="elevation-1"
                :item-class="itemRowBackground"
                >
                <template v-slot:item.opcion="{ item }">
                    <v-btn icon color="green" @click="abrirDialogProducto(item.PRO_ID)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn icon color="red" @click="eliminarProducto(item.PRO_ID)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>

                <template v-slot:item.ACTIVO="{ item }">
                    {{ item.PRO_ESTADO == 1 ? "ACTIVO" : "INACTIVO" }}
                </template>
            </v-data-table>
        </v-card>

        <!-- DIALOG PRODUCTO -->
        
        
        <v-dialog  v-model="dialogProducto" fullscreen content-class="d1"  @keydown.esc="cerrarDialogoProducto()" >
            <v-card  >
                <v-toolbar flat color="blue" dark height="40">
                    <v-icon left class="mb-1">mdi-cube-outline</v-icon>
                    <span class="headline">Producto</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cerrarDialogoProducto()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-4 pb-2">
                    
                    <v-form ref="formProducto">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="datosProducto.PRO_ID" label="Código" readonly></v-text-field>
                            </v-col>
                            <v-col cols="6" class="ml-0">
                                <v-form ref="formEstadoProducto">
                                    <v-select v-model="datosProducto.PRO_CATE_ID" :items="categoriasProducto"
                                        label="Categoria" item-text="text" item-value="value" class="mt-2"></v-select>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-text-field class="md-6" small v-model="datosProducto.PRO_DESC"
                                    label="Nombre "></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-text-field class="md-6" small v-model="datosProducto.PRO_NOMBRE_CIENTIFICO"
                                    label="Nombre científico"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-text-field class="md-6" small v-model="datosProducto.PRO_TARIFF_NUMBER"
                                    label="Tariff number"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-select v-model="datosProducto.GRUPO_TARIFA" :items="gruposTarifa"
                                    item-text="NOMBRE" item-value="GRUPO_TARIFA" label="Grupo de tarifa"
                                    :disabled="!puedeEditarGrupo" :rules="puedeEditarGrupo ? requiredRule : []"></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-checkbox v-model="datosProducto.PRO_ESTADO" label="Activo" 
                                    color="primary"></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="pt-0 pb-0" cols="12">
                                <v-autocomplete class="md-6" small v-model="datosProducto.AC_PRODUCTO_ID"
                                    :items="listaProductosAc" item-text="NOMBRE_COMUN" item-value="ID_PRODUCTO_UNICO" 
                                    label="Producto Agrocalidad"  clearable>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                        <v-list-item-title
                                            v-html="data.item.NOMBRE_COMUN"
                                        ></v-list-item-title>
                                        <v-list-item-subtitle
                                            v-html="data.item.NOMBRE_TIPO_PRODUCTO"
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            v-html="data.item.ID_PRODUCTO_UNICO"
                                        ></v-list-item-subtitle>
                                        
                                        </v-list-item-content>
                                    </template>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-toolbar flat color="white">

                    <v-btn class="mx-4" small color="primary" @click="guardarProducto()">
                        <v-icon left>mdi-content-save</v-icon> Guardar
                    </v-btn>
                    &nbsp;
                    <v-btn small @click="cerrarDialogoProducto()">
                        <v-icon left>mdi-cancel</v-icon> Cancelar
                    </v-btn>
                </v-toolbar>
            </v-card>
        </v-dialog>
        
        </div>
    
</template>
<style >
    .selectedRow {
        background-color: #e2e2e2 !important;
        border: 1px solid #0000 ;
        
        font-weight: bold;
        
    }

     .d1 {        
        margin-left: 50%;
        width: 50%;
    }
  
</style>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

import Vue from 'vue';

export default {
    name: 'ProductoComponent',
    data: () => ({
        overlay: false,
        itemsPerPage: 10,
        crearProducto: false,
        pageCount: 10,
        headers: [
            { text: 'Opciones', value: 'opcion', width: '10%' },
            { text: 'Código', value: 'PRO_ID' , width: '10px'},
            { text: 'Nombre', value: 'PRO_DESC' },
            { text: 'Descripción', value: 'PRO_NOMBRE_CIENTIFICO' },
            { text: 'Activo', value: 'PRO_ESTADO' },
        ],
        requiredRule: [(v) => !!v || 'El campo es requerido'],
        emailRules: [
            (v) => String(v).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) || 'Ingrese un Email válido',
        ],
        showToolbar: false,
        seleccionado: "",
        lista: [],
        options: {},
        dialog: false,
        notifications: false,
        sound: true,
        widgets: true,
        search: null,
        incluirInactivos: false,
        dialogProducto: false,
        datosProducto: {
            PRO_ID: '',
            PRO_DESC: '',
            PRO_ESTADO: 1,
            PRO_CATE_ID: 1, 
            PRO_NOMBRE_CIENTIFICO: '',
            PRO_TARIFF_NUMBER: '',
            HTS: '',
            GENUS_NAME: '',
            SPECIES_NAME: '',
            CODIGO_USDA: '',
            AC_PRODUCTO_ID: ''
        },
        categoriasProducto: [
            { text: 'TODOS', value: 0 },
            { text: 'FLORES', value: 1 },
            { text: 'FRUTAS', value: 2 },
        ],
        tiposProducto: [
            { text: 'TODOS', value:  0},
            { text: 'BOUQUETES', value: 1 },
            { text: 'TALLOS', value: 2 },
            
        ],
        tipoProducto:0,
        categoriaProducto: 0,
        listaProductosAc: [],
        gruposTarifa: [],
    }),
    computed: {
        ...mapGetters('master', ['loadingTable', 'user']),
        ...mapGetters("access", [
            "administrarTarifas",
        ]),
        puedeEditarGrupo() {
            return this.crearProducto || !!this.administrarTarifas;
        },
    },
    methods: {
        ...mapMutations("master", [
            "setUrl",
            "setLoadingTable",
            "setTitleToolbar",
        ]),
        ...mapActions("master", ["requestApi", "alertNotification"]),
        itemRowBackground(item) {
            if(item.PRO_ID == this.seleccionado) {
                return "selectedRow"
            }
            return ""
        },
        
        cargarLista() {
            this.setLoadingTable(true);
            this.setUrl('api/productos');
            this.requestApi({
                method: 'GET',
                data: {
                    inactivos: this.incluirInactivos,
                    tipoProducto: this.tipoProducto,
                    categoriaProducto: this.categoriaProducto,
                }
            })
                .then((res) => {
                    //console.log(res);
                    this.lista = res.data.data;
                    this.pageCount = 10;
                })
                .catch(() => { })
                .then(() => {
                    this.setLoadingTable(false);
                });
        },

        cargarGruposTarifa() {
            this.setUrl('api/tarifa-grupos');
            this.requestApi({ method: 'GET', data: {} })
                .then((res) => {
                    this.gruposTarifa = res.data.data;
                })
                .catch(() => { });
        },

        modificarProducto() {
            this.setUrl("api/modificar-producto");
            this.requestApi({
                method: "POST",
                data: {
                    pro_id: this.datosProducto.PRO_ID,
                    datosProducto: this.datosProducto,
                },
            })
                .then((res) => {
                    this.alertNotification({ param: { html: res.data.msg } });
                    this.cargarLista();
                    this.dialogProducto = false;
                })
                .catch(() => { })
                .then(() => { });
        },

        abrirDialogProducto(apid) {
            this.seleccionado = apid;
            this.crearProducto = false;
            if (apid == null) {
                this.datosProducto = {
                    PRO_ID: "",
                    PRO_DESC: "",
                    PRO_NOMBRE_CIENTIFICO: "",
                    PRO_ESTADO: 1,
                    PROD_CATE: 1,
                    PRO_TARIFF_NUMBER: "",
                    HTS: "",
                    GENUS_NAME: "",
                    SPECIES_NAME: "",
                    CODIGO_USDA: "",
                };
                this.crearProducto = true;
            }
            this.setUrl("api/producto");
            this.requestApi({
                method: "GET",
                data: {
                    id: apid,
                },
            })
                .then((res) => {
                    if (res.data.producto != null) {
                        this.datosProducto = res.data.producto;
                        this.listaProductosAc = res.data.listaProductosAc;
                    }
                    this.dialogProducto = true;
                })
                .catch(() => { })
                .then(() => { });
        },

        eliminarProducto(id) {
            Vue.swal({
                html: "Está seguro de eliminar el producto ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cerrar",
                ...this.paramAlertQuestion,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setUrl("api/borrar-producto");
                    this.requestApi({
                        method: "POST",
                        data: {
                            id: id,
                        },
                    }).then((res) => {
                        //console.log(res);
                        this.cargarLista();
                        this.alertNotification({ param: { html: res.data.msg } });
                    });
                }
            });
        },
        guardarProducto() {
            if (!this.$refs.formProducto.validate()) {
                return false;
            }
            if (this.crearProducto == true) {
                this.crearProducto();
            } else {
                this.modificarProducto();
            }
        },

        cerrarDialogoProducto(e) {
            this.seleccionado="";
            this.dialogProducto = !this.dialogProducto
            
        }

    },

    mounted() {
        this.cargarLista();
        this.cargarGruposTarifa();
    },

}

</script>
